import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Formik } from 'formik';
import './modal.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-google-places-autocomplete/dist/index.min.css';
import { toast } from 'react-toastify';
import { ButtonsWrap, FlexContainer, FlexWrap, FullWrap, ModalWrap } from './styles';
import Geocode from 'react-geocode';

const specialtiyTypes = [
  { value: 'Urologist', label: 'Urologist' },
  { value: 'Urogynecologist', label: 'Urogynecologist' },
  { value: 'OBGYN', label: 'OBGYN' },
  { value: 'Colorectal Surgeon', label: 'Colorectal Surgeon' },
  { value: 'Other', label: 'Other' },
];

const genderTypes = [
  { value: 'Male', label: 'Males' },
  { value: 'Female', label: 'Females' },
];

const patientTypes = [
  { value: 'Under 18', label: 'Under 18' },
  { value: 'Over 18', label: '18+' },
];
const productTypes = [{ value: 'Axonics SNM', label: 'Axonics SNM' },
{ value: 'Bulkamid', label: 'Bulkamid' }]
const Modaldoctor = (props) => {

  Geocode.setApiKey('AIzaSyBFTEG2DxMcjMh8FUt3lRdXyQ85wJrJj0c');

  let [formValues, setFormValues] = useState({
    Address: '',
    latLong: '',
  });
  const [checkedit, setcheckedit] = useState(false);
  let { toggle, modal, editvalue, isedit } = props;
  let initialstate = {
    email: '',
    practiceEmail: '',
    firstName: '',
    lastName: '',
    phone: '',
    centerName: '',
    websiteURL: '',
    Address: formValues.Address,
    zip: '',
    latLong: [...formValues.latLong],
    saleRepresentative: '',
    saledirector: '',
    speciality: '',
    iTreatPatient: [],
    iTreat: [],
    otherSpeciality: '',
    centerOfExcellence: false,
    productTypes:[]
  };

  useEffect(() => {
    if (isedit && editvalue) {
      initialstate = {
        email: editvalue.email,
        practiceEmail: editvalue.practiceEmail,
        firstName: editvalue.firstName,
        lastName: editvalue.lastName,
        phone: editvalue.phone,
        centerName: editvalue.centerName,
        websiteURL: editvalue.websiteURL,
        Address: editvalue.Address,
        zip: editvalue.zip,
        latLong: [...editvalue.latLong],
        saleRepresentative: editvalue.saleRepresentative,
        saledirector: editvalue.saledirector,
        speciality: editvalue.speciality,
        iTreatPatient: editvalue.iTreatPatient,
        iTreat: editvalue.iTreat,
        otherSpeciality: editvalue.otherSpeciality,
        centerOfExcellence: editvalue.centerOfExcellence,
        productTypes: editvalue.productTypes ? editvalue.productTypes : []
      };
      setcheckedit(!checkedit);
    }
  }, [isedit]);

  toast.configure();

  const {
    buttonLabel,
    className,
  } = props;
  // const [modal, setModal] = useState(false);

  const handleAddess = (input) => {
    let latlongValues;
    const nameValue = { ...formValues, Address: input };
    setFormValues(nameValue);
    Geocode.fromAddress(nameValue.Address).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location;
        latlongValues = [lng, lat];
        let latValues = { ...nameValue, latLong: latlongValues };
        setFormValues(latValues);
      },
      error => {
        console.error(error);
      },
    );
    // geocodeByAddress(nameValue.Address)
    //   .then(results => getLatLng(results[0]))
    //   .then(({ lat, lng }) => {
    //     latlongValues = [lng, lat]
    //     let latValues = { ...nameValue, latLong: latlongValues }
    //     setFormValues(latValues)
    //   }
    //   );
  };

  // const toggle = () => setModal(!modal);
  const handleCheckBox = (value, type, values) => {
    if (type == 'speciality') {
      if (values == value) {
        return '';
      } else {
        return value;
      }
    }
    if (type == 'patient') {
      let index = values.indexOf(value);
      if (index === -1) {
        values.push(value);
      } else {
        values.splice(index, 1);
      }
      return values;
      // setFieldValue('iTreatPatient', values);
    }
    if (type == 'gender') {
      let index = values.indexOf(value);
      if (index === -1) {
        values.push(value);
      } else {
        values.splice(index, 1);
      }
      return values;
      // setFieldValue('iTreat', values);
    }
    if (type == 'productTypes') {
      let index = values.indexOf(value);
      if (index === -1) {
        values.push(value);
      } else {
        values.splice(index, 1);
      }
      return values;
      // setFieldValue('iTreat', values);
    }
  };
  const isChecked = (values, value) => {
    if (values && values.includes(value)) {
      return true;
    } else {
      return false;
    }
  };



  return (
    <FullWrap className="modal-top-section">

      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalWrap>
          <ModalHeader toggle={toggle}>{isedit
            ? `Edit`
            : `Add`} Doctor</ModalHeader>
          <ModalBody>
            <Formik
              initialValues={{
                email: (isedit && editvalue) ? editvalue.email : '',
                practiceEmail: (isedit && editvalue)
                  ? editvalue.practiceEmail
                  : '',
                firstName: (isedit && editvalue)
                  ? editvalue.firstName
                  : (isedit && editvalue) ? editvalue.firstName : '',
                lastName: (isedit && editvalue) ? editvalue.lastName : '',
                phone: (isedit && editvalue) ? editvalue.phone : '',
                centerName: (isedit && editvalue)
                  ? editvalue.centerName
                  : '',
                websiteURL: (isedit && editvalue)
                  ? editvalue.websiteURL
                  : '',
                saleRepresentative: (isedit && editvalue)
                  ? editvalue.saleRepresentative
                  : '',
                saledirector: (isedit && editvalue)
                  ? editvalue.saledirector
                  : '',
                // Address: (isedit && editvalue) ? editvalue.Address : formValues.Address,
                Address: (formValues.Address !== '')
                  ? formValues.Address
                  : (isedit && editvalue) ? editvalue.Address : '',
                zip: (isedit && editvalue) ? editvalue.zip : '',
                letLong: (formValues.latLong !== '')
                  ? formValues.latLong
                  : (isedit && editvalue) ? editvalue.latLong : '',
                speciality: (isedit && editvalue)
                  ? editvalue.speciality
                  : '',
                iTreatPatient: (isedit && editvalue)
                  ? editvalue.iTreatPatient
                  : [],
                iTreat: (isedit && editvalue) ? editvalue.iTreat : [],
                otherSpeciality: (isedit && editvalue)
                  ? editvalue.otherSpeciality
                  : '',
                centerOfExcellence: (isedit && editvalue)
                  ? editvalue.centerOfExcellence
                  : false,
                productTypes:(isedit && editvalue) ? (editvalue.productTypes ? editvalue.productTypes : []) : [],
                // latLong: (isedit && editvalue) ? editvalue.latLong : [...formValues.latLong]
              }}
              onSubmit={(values, { setSubmitting }) => {
                values.Address = (formValues.Address !== '')
                  ? formValues.Address
                  : (isedit && editvalue) ? editvalue.Address : '';
                values.latLong = (formValues.latLong !== '')
                  ? formValues.latLong
                  : (isedit && editvalue) ? editvalue.latLong : '';
                values.otherSpeciality = values.speciality &&
                  values.speciality.toLowerCase() == 'other'
                  ? values.otherSpeciality
                  : '';
                // setTimeout(() => {
                //   setSubmitting(false);
                // }, 400);
                // return
                if (values.zip.length > 4) {
                  if (!isedit) {
                    props.handleAddSubmit(values);
                    setFormValues({
                      Address: '',
                      latLong: '',
                    });
                  } else {
                    props.handleEditapi(values, values._id = editvalue._id);
                    setFormValues({
                      Address: '',
                      latLong: '',
                    });
                  }
                  // setTimeout(() => {
                  //   setSubmitting(false);
                  // }, 400);
                } else {
                  toast.error('Zipcode must be atleast 5 digits');
                  // setTimeout(() => {
                  //   setSubmitting(false);
                  // }, 400);
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting,
              }) => (
                  <form onSubmit={handleSubmit}>
                    {!isedit ? (
                      <div>
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={true}

                        />
                        {errors.email && touched.email && errors.email}
                      </div>) : (
                        <div>
                          <label>Email</label>
                          <input
                            type="email"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={true}
                            value={values.email}
                          />
                          {errors.email && touched.email && errors.email}
                        </div>
                      )}
                    {!isedit ? (
                      <div>
                        <label>Practice Email</label>
                        <input
                          type="email"
                          name="practiceEmail"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={true}

                        />
                        {errors.email && touched.email && errors.email}
                      </div>) : (
                        <div>
                          <label>Practice Email</label>
                          <input
                            type="email"
                            name="practiceEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.practiceEmail}
                            disabled={true}
                          />
                          {errors.email && touched.email && errors.email}
                        </div>
                      )}
                    {!isedit ? (
                      <div>
                        <label>First Name</label>
                        <input
                          type="text"
                          name="firstName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          required
                          disabled={true}
                        />
                        {errors.firstName && touched.firstName &&
                          errors.firstName}
                      </div>) : (
                        <div>
                          <label>First Name</label>
                          <input
                            type="text"
                            name="firstName"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.firstName}
                            disabled={true}
                          />
                          {errors.firstName && touched.firstName &&
                            errors.firstName}
                        </div>
                      )}
                    {!isedit ? (
                      <div>
                        <label>Last Name</label>
                        <input
                          type="text"
                          name="lastName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={true}
                        />
                        {errors.lastName && touched.lastName &&
                          errors.lastName}
                      </div>) : (
                        <div>
                          <label>Last Name</label>
                          <input
                            type="text"
                            name="lastName"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.lastName}
                            disabled={true}
                          />
                          {errors.lastName && touched.lastName &&
                            errors.lastName}
                        </div>
                      )}
                    {!isedit ? (
                      <div>
                        <label>Phone</label>
                        <input
                          type="text"
                          name="phone"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={true}

                        />
                        {errors.phone && touched.phone && errors.phone}
                      </div>) : (
                        <div>
                          <label>Phone</label>
                          <input
                            type="text"
                            name="phone"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone}
                            disabled={true}
                          />
                          {errors.phone && touched.phone && errors.phone}
                        </div>
                      )}
                    {!isedit ? (
                      <div>
                        <label>Practice Name</label>
                        <input
                          type="text"
                          name="centerName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={true}
                        />
                        {errors.centerName && touched.centerName &&
                          errors.centerName}
                      </div>) : (
                        <div>
                          <label>Practice Name</label>
                          <input
                            type="text"
                            name="centerName"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.centerName}
                            disabled={true}
                          />
                          {errors.centerName && touched.centerName &&
                            errors.centerName}
                        </div>
                      )}
                    {!isedit ? (
                      <div>
                        <label>Website URL</label>
                        <input
                          type="text"
                          name="websiteURL"
                          disabled={true}
                          onChange={handleChange}
                          onBlur={handleBlur}


                        />
                        {errors.websiteURL && touched.websiteURL &&
                          errors.websiteURL}
                      </div>) : (
                        <div>
                          <label>Website URL</label>
                          <input
                            type="text"
                            name="websiteURL"
                            disabled={true}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.websiteURL}

                          />
                          {errors.websiteURL && touched.websiteURL &&
                            errors.websiteURL}
                        </div>
                      )}
                    {!isedit ? (
                      <div>
                        <label for="exampleText">Address</label>
                        <input
                          type="text"
                          name="Address"
                          disabled={true}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            setFieldValue('Address', e.target.value);
                            handleAddess(e.target.value);
                          }}
                          // initialValue={values.Address}
                          required

                        />
                      </div>
                    ) : (
                        <div>
                          <label for="exampleText">Address</label>
                          <input
                            type="text"
                            name="Address"
                            onBlur={handleBlur}
                            disabled={true}
                            onChange={(e) => {
                              setFieldValue('Address', e.target.value);
                              handleAddess(e.target.value);
                            }}
                            defaultValue={values.Address}
                            // initialValue={values.Address}
                            required
                          />
                        </div>
                      )}
                    {/* {!isedit ? (
                       <div>
                       <Label for="exampleText">Address</Label>
                       <GooglePlacesAutocomplete
                       onSelect={e => handleAddess(e)}
                       // initialValue={values.Address}
                       required


                       />
                       </div>
                       ) : (
                       <div>
                       <Label for="exampleText">Address</Label>
                       <GooglePlacesAutocomplete
                       onSelect={e => handleAddess(e)}
                       initialValue={values.Address}

                       />
                       </div>
                       )} */ }
                    {!isedit ? (
                      <div>
                        <label>Zip</label>
                        <input
                          type="text"
                          name="zip"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          required
                          disabled={true}
                        />
                        {errors.zip && touched.zip && errors.zip}
                      </div>) : (
                        <div>
                          <label>Zip</label>
                          <input
                            type="text"
                            name="zip"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.zip}
                            required
                            disabled={true}
                          />
                          {errors.zip && touched.zip && errors.zip}
                        </div>
                      )}
                    {!isedit ? (
                      <div>
                        <label>Sale Representative</label>
                        <input
                          type="text"
                          name="saleRepresentative"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={true}

                        />
                        {errors.saleRepresentative &&
                          touched.saleRepresentative &&
                          errors.saleRepresentative}
                      </div>) : (
                        <div>
                          <label>Sale Representative</label>
                          <input
                            type="text"
                            name="saleRepresentative"
                            disabled={true}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.saleRepresentative}


                          />
                          {errors.saleRepresentative &&
                            touched.saleRepresentative &&
                            errors.saleRepresentative}
                        </div>
                      )}
                    {!isedit ? (
                      <div>
                        <label>Sale Director</label>
                        <input
                          type="text"
                          name="saledirector"
                          disabled={true}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.saledirector && touched.saledirector &&
                          errors.saledirector}
                      </div>) : (
                        <div>
                          <label>Sale Director</label>
                          <input
                            type="text"
                            name="saledirector"
                            disabled={true}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.saledirector}
                          />
                          {errors.saledirector && touched.saledirector &&
                            errors.saledirector}
                        </div>
                      )}

                    <FlexWrap>
                      <input
                        name="centerOfExcellence"
                        type="checkbox"
                        disabled={true}
                        checked={values.centerOfExcellence}
                        onChange={handleChange} />
                      <p>Center of Excellence</p>
                    </FlexWrap>

                    <label>
                      Please select your preferred specialty
                      </label>
                    <FlexContainer>
                      {specialtiyTypes.map(speciality =>
                        <FlexWrap>
                          <input
                            name={speciality.value}
                            type="checkbox"
                            disabled={true}
                            checked={values.speciality ==
                              speciality.value}
                            onChange={e => {
                              let data = handleCheckBox(speciality.value,
                                'speciality', values.speciality);
                              setFieldValue('speciality', data);
                            }} />
                          <p>{speciality.label}</p>
                        </FlexWrap>,
                      )}
                    </FlexContainer>
                    {values.speciality && values.speciality.toLowerCase() ==
                      'other' ?
                      <div>
                        {!isedit ? (
                          <div>
                            <label>Other Speciality</label>
                            <input
                              type="text"
                              name="otherSpeciality"
                              disabled={true}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.otherSpeciality &&
                              touched.otherSpeciality &&
                              errors.otherSpeciality}
                          </div>) : (
                            <div>
                              <label>Other Speciality</label>
                              <input
                                type="text"
                                name="otherSpeciality"
                                disabled={true}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.otherSpeciality}

                              />
                              {errors.otherSpeciality &&
                                touched.otherSpeciality &&
                                errors.otherSpeciality}
                            </div>
                          )}
                      </div> : null}

                      <label>
                      Products Used
                      </label>
                      <FlexContainer>
                        { productTypes.map(product =>
                            <FlexWrap>
                              <input
                                  name={ product.value }
                                  type="checkbox"
                                  disabled={true}
                                  checked={isChecked(values.productTypes,
                                    product.value)}
                                  onChange={ e => {
                                    let data = handleCheckBox(product.value,
                                        'productTypes', values.productTypes);
                                    setFieldValue('productTypes', data);
                                  } }/>
                              <p>{ product.label }</p>
                            </FlexWrap>,
                        ) }
                      </FlexContainer>

                    <FlexContainer style={{ flexWrap: 'nowrap' }}>
                      <div style={{
                        borderRight: '1px solid #ccc',
                        marginRight: '10px',
                        paddingRight: '10px',
                      }}>
                        <label>
                          I treat patients <span style={{ fontSize: 10 }}>(Select all that apply)</span>
                        </label>
                        <FlexContainer>
                          {patientTypes.map(type => <FlexWrap>
                            <input
                              name={type.value}
                              disabled={true}
                              type="checkbox"
                              checked={isChecked(values.iTreatPatient,
                                type.value)}
                              onChange={e => {
                                let data = handleCheckBox(type.value,
                                  'patient', values.iTreatPatient);
                                setFieldValue('iTreatPatient', data);
                              }
                              } />
                            <p>{type.label}</p>
                          </FlexWrap>,
                          )
                          }
                          {/* <FlexWrap>
                             <input
                             name="18+"
                             type="checkbox"
                             // checked={this.state.isGoing}
                             onChange={e=>handleCheckBox(e,'patient')} />
                             <p>18+</p>
                             </FlexWrap> */ }
                        </FlexContainer>

                      </div>
                      <div>
                        <label>
                          I treat <span style={{ fontSize: 10 }}>(Select all that apply)</span>
                        </label>
                        <FlexContainer>
                          {genderTypes.map(type => <FlexWrap>
                            <input
                              name={type.value}
                              type="checkbox"
                              disabled={true}
                              checked={isChecked(values.iTreat,
                                type.value)}
                              onChange={e => {
                                let data = handleCheckBox(type.value,
                                  'gender', values.iTreat);
                                setFieldValue('iTreat', data);
                              }} />
                            <p>{type.label}</p>
                          </FlexWrap>,
                          )}

                        </FlexContainer>
                      </div>
                    </FlexContainer>
                    <ButtonsWrap>
                      {/*<button type="submit" disabled={props.isLoading}*/}
                      {/*  className="submit-btn">*/}
                      {/*  { props.isLoading ? <Spinner*/}
                      {/*    as="span"*/}
                      {/*    animation="border"*/}
                      {/*    size="sm"*/}
                      {/*    role="status"*/}
                      {/*    aria-hidden="true"*/}
                      {/*  /> : 'Submit' }*/}
                      {/*  </button>*/}
                      <Button color="secondary" onClick={toggle}
                        className="cancel-btn">Cancel</Button>
                    </ButtonsWrap>
                  </form>
                )}
            </Formik>
          </ModalBody>
        </ModalWrap>
      </Modal>
    </FullWrap>
  );
};

export default Modaldoctor;



// WEBPACK FOOTER //
// ./src/component/Modaldoctor/index.js